import { ref } from 'vue'

const isOpen = ref(false)
const query = ref('')

export function useAdminGlobalSearch() {
  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
    query.value = ''
  }

  return {
    isOpen,
    query,
    open,
    close,
  }
}
